// SITE TYPES
export const siteTypes = {
  SET_DEVICES: "SET_DEVICES",
  SET_SELECTED_DEVICE: "SET_SELECTED_DEVICE",
  SET_MAP_DISPLAY: "SET_MAP_DISPLAY",
  SET_MAP_OPTION: "SET_MAP_OPTION",
  SET_HISTORY: "SET_HISTORY",
};
